import { FC, useEffect, useState } from "react";
import { LoadingStatus } from "../../../@types/enumsGlobal";
import { DefaultGrid } from "../../../components/grids/default/defaultGrid";
import { PluginWrapper } from "../../../components/plugins";
import useGridFilter, { CreateSelectorGridFilter } from "../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../system/providers/appContextProvider";
import { IExportToolsViewDTO } from "../../../libs/coreapi-dto/dirs/exportDocument";
import { ExportDocumentDataProvider } from "../../../Services/DataProviders/ExportDocumentDataProvider";
import { ExportDocumentToolsCommandsPanel } from "./ExportDocumentToolsCommandsPanel";


const ExportDocumentToolsGrid: FC<IGridProps> = (props) => {
    const appCtx = useAppContext()
    const exportProvider = new ExportDocumentDataProvider(appCtx.coreApiService)

    const dafaultName = 'Настройка по умолчанию'

    const [data, setData] = useState<IExportToolsViewDTO[]>([]);
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.InProcess);
    const [totalCount, setTotalCount] = useState(0);
    const [viewState, setViewState] = useState<GridStateType>("view");
    const [gridFilter, dispatchGridFilter] = useGridFilter(props.baseGridFilter ?? { fieldOrderBy: 'name',
        columnFilters: [
        ...CreateSelectorGridFilter.columnFilters, 
        {
            name: 'name',
            operator: 'NotEq',
            value: dafaultName
        }]
    });
    const [selectedItem, setSelectedItem] = useState<IGridRow>();

    useEffect(() => {
        getView();
    }, [viewState, gridFilter])


    const getView = () => {
        setSelectedItem(undefined);
        setLoadingStatus(LoadingStatus.InProcess)
        exportProvider.getView(gridFilter, (data, totalCount) => {
            setData(data)
            setTotalCount(totalCount)
            data.length > 0 ? setLoadingStatus(LoadingStatus.Completed) : setLoadingStatus(LoadingStatus.NoData)
        })
    }

    return (
        <PluginWrapper>
            { 
                <ExportDocumentToolsCommandsPanel
                    getView={getView}
                    data={data}
                    selectedItem={selectedItem}
                    dispatchGridFilter={dispatchGridFilter}
                    permission={props.plugin.permission}
                />
            }
            {
                 <DefaultGrid
                    showQuantity
                    separator
                    gridId={props.gridId}
                    data={data}
                    loadingStatus={loadingStatus}
                    setLoadingStatus={setLoadingStatus}
                    totalCount={totalCount}
                    filter={gridFilter}
                    dataProvider={exportProvider}
                    plugin={props.plugin}
                    selectedItem={selectedItem}
                    onSelect={(row) => {
                        setSelectedItem(row)
                        props.onSelect?.(row)
                    }}
                    onDoubleClick={(i) => props.onDoubleClick?.(i)}
                    onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                    onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
                    onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                    onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                    onEnter={() => setViewState("edit")}
                />
            }
        </PluginWrapper>
    )
}

export default ExportDocumentToolsGrid